// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"R1-z","colorTextValue":"S1-z","swatches":"T1-z","collapseLink":"U1-z","isCollapsed":"V1-z","dropdown":"W1-z","disabled":"X1-z"};